/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiComponentBlockFromJSON(json) {
    return ApiComponentBlockFromJSONTyped(json, false);
}
export function ApiComponentBlockFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'css': !exists(json, 'css') ? undefined : json['css'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'js': !exists(json, 'js') ? undefined : json['js'],
    };
}
export function ApiComponentBlockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'css': value.css,
        'html': value.html,
        'js': value.js,
    };
}
